export default {
  deca: state => state.deca
};
